import React, { useEffect, useState } from "react";
import PhoneCallApplicantPopup from "./PhoneCallApplicantPopup";
import Moment from "react-moment";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  addAppPhoneCall, deleteAppPhoneCall, getAppPhoneCalls,
  getAppPhoneCallsAddedStatus, getAppPhoneCallsDeletedStatus,
  getAppPhoneCallsUpdatedStatus, loadAppPhoneCalls, updateAppPhoneCall,
  getAppPhoneCallsLoading, getAppPhoneCallsDeleteLoading
} from "../../app/store/phoneCall";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import NotesPopover from "../../comman/NotesPopover";

const PhoneCallApplicant = (props) => {
  const { workflowTask, handleUpdateComponent } = props;
  const [appPhoneCalls, setAppPhoneCalls] = useState([]);
  const [selectedPhoneCallId, setSelectedPhoneCallId] = useState(0);
  const [selectedPhoneCall, setSelectedPhoneCall] = useState(null);
  const [selectedKey, setSelectedKey] = useState("home");
  const [updateCompStatus, setUpdateCompStatus] = useState(false);
  const [deletingPhoneId, setDeletingPhoneId] = useState(null);

  const appPhoneCallsSelector = useSelector(getAppPhoneCalls);
  const appPhoneCallsAddedStatusSelector = useSelector(getAppPhoneCallsAddedStatus);
  const appPhoneCallsDeletedStatusSelector = useSelector(getAppPhoneCallsDeletedStatus);
  const appPhoneCallsUpdatedStatusSelector = useSelector(getAppPhoneCallsUpdatedStatus);
  const isLoading = useSelector(getAppPhoneCallsLoading);
  const isDeleteLoading = useSelector(getAppPhoneCallsDeleteLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser()

  useEffect(() => {
    if (workflowTask?.ciid) {
      dispatch(loadAppPhoneCalls(workflowTask.ciid))
      setUpdateCompStatus(true);
    }

  }, []);

  useEffect(() => {
    if (appPhoneCallsSelector.length > 0) {
      setAppPhoneCalls(appPhoneCallsSelector)
      let callItems = "";
      appPhoneCallsSelector.map((x, key) => {
        if (key > 0) callItems += ",";
        callItems += x.phoneId;
      })
      if (updateCompStatus) {
        handleUpdateComponent(callItems);
        setUpdateCompStatus(false);
      }
    } else {
      setAppPhoneCalls([]);
    }

  }, [appPhoneCallsSelector]);

  const handleSubmit = async (data) => {
    const phoneCell = {
      callDate: data["callDate"],
      callTime: data["callTime"],
      comments: data["comments"],
      duration: data["duration"],
      wiid: workflowTask.wiid,
      ciid: workflowTask.ciid,
      performerId: currentUser.id,
    };
    dispatch(addAppPhoneCall(phoneCell));
  };

  useEffect(() => {
    if (appPhoneCallsAddedStatusSelector && workflowTask?.ciid) {
      getAlert("", "Added Successfully", "success");
      dispatch(loadAppPhoneCalls(workflowTask.ciid));
      setUpdateCompStatus(true);
      setSelectedKey("home");
      setSelectedPhoneCallId(0);
    }
  }, [appPhoneCallsAddedStatusSelector]);

  useEffect(() => {
    if (appPhoneCallsUpdatedStatusSelector && workflowTask?.ciid) {
      getAlert("", "Updated Successfully", "success");
      dispatch(loadAppPhoneCalls(workflowTask.ciid));
      setSelectedKey("home");
      setSelectedPhoneCallId(0);
    }
  }, [appPhoneCallsUpdatedStatusSelector]);

  useEffect(() => {
    if (appPhoneCallsDeletedStatusSelector && workflowTask?.ciid) {
      setDeletingPhoneId(null);
      getAlert("", "Deleted Successfully", "success");
      dispatch(loadAppPhoneCalls(workflowTask.ciid));
      setUpdateCompStatus(true);
      handleResetSelection();
    }
  }, [appPhoneCallsDeletedStatusSelector])


  const handleEditComment = (item) => {
    dispatch(updateAppPhoneCall(item));
  };

  const handleDeleteComment = async (item) => {
    const result = await getConfirmAlert("Warning", "Are you sure, you want to Delete this Phone Call Notes", "warning");
    if (result.isConfirmed) {
      setDeletingPhoneId(item.phoneId);
      dispatch(deleteAppPhoneCall(item));
    }
  };

  const handleSelectTab = (tab) => {
    setSelectedKey(tab);
  }

  const handleResetSelection = () => {
    setSelectedPhoneCallId(0);
    setSelectedPhoneCall(null);
  }

  const handleSelectPhoneCall = (phone) => {
    if (selectedPhoneCallId === phone.phoneId) {
      handleResetSelection();
    } else {
      setSelectedPhoneCall(phone);
      setSelectedPhoneCallId(phone.phoneId);
    }
  }

  const renderSelectedCallCard = () => {
    if (selectedPhoneCallId === 0 || !selectedPhoneCall) return null;

    return (
      <div className="rt-msg-selected-card">
        <div className="rt-msg-selected-info">
          <div className="rt-msg-selected-avatar">
            <i className="fa fa-phone" aria-hidden="true" style={{ fontSize: "20px" }} />
          </div>
          <div className="rt-msg-selected-meta">
            <strong>
              <Moment format="MMM D, YYYY">{selectedPhoneCall.callDate}</Moment>
              {" at "}
              {moment(selectedPhoneCall.callTime?.replace(":00", ""), "hhmm").format("h:mm a")}
            </strong>
            <span>
              <i className="fa fa-hourglass-half" aria-hidden="true" />
              {selectedPhoneCall.duration} Min
              <span>&bull;</span>
              <span className="rt-form-status-tag is-updated">Logged</span>
            </span>
          </div>
        </div>
        <div className="rt-msg-selected-actions">
          <button
            className="btn-action-search"
            onClick={() => handleSelectTab("profile")}
            type="button"
          >
            <i className="fa fa-pencil" aria-hidden="true" /> Edit Note
          </button>
          <button
            className="btn-action-search btn-danger-search"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteComment(selectedPhoneCall);
            }}
            type="button"
            title="Delete Call Log"
            disabled={isDeleteLoading && deletingPhoneId === selectedPhoneCall.phoneId}
          >
            {isDeleteLoading && deletingPhoneId === selectedPhoneCall.phoneId ? (
              <><i className="fa fa-spinner fa-spin" aria-hidden="true" /> Deleting...</>
            ) : (
              <><i className="fa fa-trash-o" aria-hidden="true" /> Delete</>
            )}
          </button>
          <button
            className="btn-action-search btn-danger-search"
            onClick={handleResetSelection}
            type="button"
            title="Clear selection"
            style={{ minWidth: "32px", padding: "7px 10px" }}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  const skeletonWidths = ["sk-medium", "sk-short", "sk-short", "sk-long", "sk-medium", "sk-short"];

  return (
    <React.Fragment>
      <div className="rt-form-workbench">
        <style>{`
          .rt-form-workbench {
            background: transparent !important;
            color: #334155 !important;
            --task-accent: #2563eb !important;
            --task-soft: #eff6ff !important;
            --primary-color: #2563eb;
            --primary-hover: #1d4ed8;
            --primary-soft: #eff6ff;
            --secondary-color: #64748b;
            --secondary-hover: #475569;
            --border-color: #e2e8f0;
            --bg-light: #f8fafc;
            --text-main: #1e293b;
            --text-muted: #64748b;
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
            position: relative;
          }

          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }

          .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #171717, #737373, #171717) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }

          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }

          .skeleton-cell {
            display: block;
            height: 13px;
            border-radius: 0 !important;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            );
            background-size: 600px 100%;
            animation: shimmer 1.4s ease-in-out infinite;
          }

          .skeleton-cell.sk-short  { width: 40%; }
          .skeleton-cell.sk-medium { width: 65%; }
          .skeleton-cell.sk-long   { width: 85%; }
          .skeleton-cell.sk-full   { width: 92%; }

          .skeleton-row td {
            padding: 14px 16px !important;
          }

          .rt-tools-modal .modal-body .rt-msg-tab-bar,
          .rt-msg-tab-bar {
            display: flex !important;
            align-items: stretch !important;
            gap: 4px !important;
            border-bottom: 2px solid #e5e5e5 !important;
            margin-bottom: 16px !important;
            padding: 8px 0 0 !important;
            position: relative;
          }

          .rt-msg-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: none;
            background: transparent;
            padding: 9px 16px 11px;
            font-size: 14px;
            font-weight: 500;
            color: #64748b;
            cursor: pointer;
            border-radius: 0 !important;
            transition: color 0.2s ease, background 0.2s ease;
            outline: none;
            white-space: nowrap;
          }
          .rt-msg-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .rt-msg-tab-btn:hover {
            color: #1e293b;
            background: rgba(37,99,235,0.04);
          }
          .rt-msg-tab-btn:focus,
          .rt-msg-tab-btn:focus-visible,
          .rt-msg-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-msg-tab-btn.active {
            color: var(--task-accent, #2563eb) !important;
            font-weight: 500 !important;
            background: var(--task-soft, rgba(37,99,235,0.06)) !important;
          }
          .rt-msg-tab-btn.active i {
            color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 2px;
            background: var(--task-accent, #2563eb);
            border-radius: 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .rt-msg-tab-btn.active::after {
            transform: scaleX(1);
          }
          .rt-msg-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 0 !important;
            font-size: 12px;
            font-weight: 600;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
            transition: all 0.2s ease;
          }
          .rt-msg-tab-btn.active .rt-msg-tab-badge {
            background: var(--task-soft, rgba(37,99,235,0.1)) !important;
            color: var(--task-accent, #1d4ed8) !important;
            border-color: var(--task-accent, rgba(37,99,235,0.2)) !important;
          }

          .rt-msg-panel {
            animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
            min-height: 0 !important;
            overflow: visible !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
          }
          .rt-msg-panel.is-form-panel {
            padding-top: 4px !important;
          }
          @keyframes rtMsgTabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .rt-msg-selected-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 14px !important;
            padding: 12px 18px !important;
            margin: 0 0 16px 0 !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            box-shadow: none !important;
            flex-wrap: wrap !important;
            animation: rtMsgTabFadeIn 0.3s ease both !important;
          }
          .rt-msg-selected-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-avatar {
            width: 40px !important;
            height: 40px !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            color: #0f172a !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 16px !important;
            font-weight: 600 !important;
            flex-shrink: 0 !important;
            box-shadow: none !important;
          }
          .rt-msg-selected-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-meta strong {
            display: block !important;
            color: #0f172a !important;
            font-size: 14px !important;
            font-weight: 600 !important;
            margin-bottom: 2px !important;
          }
          .rt-msg-selected-meta span {
            color: #64748b !important;
            font-size: 12px !important;
            font-weight: 400 !important;
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
          }
          .rt-msg-selected-actions {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            flex-shrink: 0 !important;
          }

          .btn-action-search {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 7px 14px !important;
            min-height: 32px !important;
            height: auto !important;
            box-sizing: border-box !important;
            border-radius: 0 !important;
            font-family: inherit !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            color: #1e293b !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            outline: none !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          }
          .btn-action-search:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
          }
          .btn-action-search.btn-danger-search {
            background: #ffffff !important;
            color: #dc2626 !important;
            border: 1px solid #cbd5e1 !important;
          }
          .btn-action-search.btn-danger-search:hover {
            background: #fef2f2 !important;
            color: #b91c1c !important;
            border-color: #fca5a5 !important;
          }

          .table-responsive.rt-msg-table-scroll,
          .rt-msg-table-scroll {
            overflow: auto !important;
            max-height: 460px !important;
            border: none !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            position: relative !important;
            box-shadow: none !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
          }
          .rt-msg-table {
            width: 100% !important;
            margin-bottom: 0 !important;
            margin-top: 0 !important;
            border: none !important;
            border-collapse: collapse !important;
            color: #1e293b !important;
          }
          .rt-msg-table thead {
            position: sticky;
            top: 0;
            z-index: 2;
            background: #f8fafc !important;
          }
          .rt-msg-table thead th {
            background: #f8fafc !important;
            color: #64748b !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            letter-spacing: 0.05em !important;
            text-transform: uppercase !important;
            padding: 11px 16px !important;
            border: none !important;
            border-bottom: 1px solid #e2e8f0 !important;
            white-space: nowrap !important;
          }
          .rt-form-workbench .rt-msg-table td {
            padding: 12px 16px !important;
            font-size: 13.5px !important;
            font-weight: 400 !important;
            color: #1e293b !important;
            vertical-align: top !important !important;
            border: none !important;
            border-bottom: 1px solid #f1f5f9 !important;
            background: transparent !important;
            transition: all 0.15s ease !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr:last-child td {
            border-bottom: none !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row {
            cursor: pointer !important;
            transition: background 0.15s ease, box-shadow 0.15s ease !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover {
            background-color: rgba(37, 99, 235, 0.04) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
            box-shadow: inset 3px 0 0 0 #171717 !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row {
            background-color: #f1f5f9 !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td {
            color: #0f172a !important;
            font-weight: 500 !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
            box-shadow: inset 4px 0 0 0 #171717 !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row:hover {
            background-color: rgba(37, 99, 235, 0.09) !important;
          }

          .rt-msg-time {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 2px !important;
          }
          .rt-msg-time-date {
            font-weight: 500 !important;
            color: #1e293b !important;
            font-size: 13.5px !important;
            line-height: 1.2 !important;
          }
          .rt-msg-time-subtext {
            font-size: 12px !important;
            font-weight: 400 !important;
            color: #64748b !important;
            line-height: 1.2 !important;
            padding-left: 0 !important;
            margin: 0 !important;
          }

          .rt-msg-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 220px;
            padding: 36px 20px;
            text-align: center;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            border-radius: 0 !important;
          }
          .rt-msg-empty-icon {
            width: 48px;
            height: 48px;
            border-radius: 0 !important;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: #f8fafc;
            border: 1px solid #cbd5e1;
            color: #2563eb;
            font-size: 20px;
            margin-bottom: 14px;
          }
          .rt-msg-empty-title { margin: 0; color: #1e293b; font-size: 14px; font-weight: 600; }
          .rt-msg-empty-desc { margin: 6px 0 0; color: #64748b; font-size: 13px; font-weight: 400; }

          .wf-name-cell {
            display: flex !important;
            align-items: flex-start !important;
            gap: 10px !important;
            min-width: 190px !important;
          }
          .wf-name-avatar {
            width: 32px !important;
            height: 32px !important;
            border-radius: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: #f5f5f5 !important;
            border: 1px solid #d4d4d4 !important;
            color: #1e293b !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            flex-shrink: 0 !important;
          }
          .wf-name-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .wf-name-main {
            font-weight: 500 !important;
            color: #1e293b !important;
            font-size: 13.5px !important;
            line-height: 1.2 !important;
          }
          .wf-name-title {
            font-size: 12px !important;
            color: #64748b !important;
            font-weight: 400 !important;
            line-height: 1.2 !important;
          }
          .wf-empty-value {
            color: #94a3b8 !important;
            font-size: 13px !important;
            font-weight: 400 !important;
          }

          .rt-form-status-tag {
            font-size: 11px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            padding: 2px 6px !important;
            border-radius: 0 !important;
            letter-spacing: 0.02em !important;
            display: inline-block !important;
          }
          .rt-form-status-tag.is-updated {
            background: #ecfdf5 !important;
            color: #065f46 !important;
            border: 1px solid #a7f3d0 !important;
          }

          .rt-call-duration-tag {
            font-size: 11.5px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            background: #ecfdf5 !important;
            color: #065f46 !important;
            border: 1px solid #a7f3d0 !important;
            padding: 3px 7px !important;
            border-radius: 0 !important;
            letter-spacing: 0.02em !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
          }
`}</style>

        {/* ─── Tab Bar ─── */}
        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn ${selectedKey === "home" ? "active" : ""}`}
            onClick={() => handleSelectTab("home")}
          >
            <i className="fa fa-phone" />
            Phone Call Notes
            <span className="rt-msg-tab-badge">{appPhoneCalls.length}</span>
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn ${selectedKey === "profile" ? "active" : ""}`}
            onClick={() => handleSelectTab("profile")}
          >
            <i className={`fa ${selectedPhoneCallId > 0 ? "fa-pencil" : "fa-plus"}`} />
            {selectedPhoneCallId > 0 ? "Edit Note" : "Add Note"}
          </button>
        </div>

        {/* ─── Home Tab ─── */}
        {selectedKey === "home" && (
          <div className="rt-msg-panel">
            {renderSelectedCallCard()}

            {!isLoading && appPhoneCalls.length === 0 ? (
              <div className="rt-msg-empty-state">
                <div className="rt-msg-empty-icon"><i className="fa fa-phone" /></div>
                <p className="rt-msg-empty-title">No Phone Call Notes</p>
                <p className="rt-msg-empty-desc">Click "Add Note" to log a phone call with the applicant.</p>
              </div>
            ) : (
              <div className="table-responsive rt-msg-table-scroll">
                <table className="table align-items-center table-flush rt-msg-table">
                  <thead>
                    {isLoading && (
                      <tr style={{ height: "0px", padding: 0 }}>
                        <th colSpan={5} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                          <div className="wf-loading-bar" />
                        </th>
                      </tr>
                    )}
                    <tr>
                      <th>#</th>
                      <th>Date & Time</th>
                      <th>Duration</th>
                      <th>Notes</th>
                      <th>Logged By</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      [...Array(4)].map((_, i) => (
                        <tr key={`sk-${i}`} className="skeleton-row">
                          {skeletonWidths.map((w, j) => (
                            <td key={j}><span className={`skeleton-cell ${w}`} /></td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      appPhoneCalls.map((item, key) => {
                        const isSelected = selectedPhoneCallId === item.phoneId;
                        const canDelete = workflowTask.wiid === item.wiid;

                        return (
                          <tr
                            key={item.phoneId}
                            className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                            onClick={() => handleSelectPhoneCall(item)}
                          >
                            <td style={{ width: "40px", fontWeight: 400, color: "#94a3b8" }}>
                              {key + 1}
                            </td>
                            <td>
                              <div className="rt-msg-time">
                                <span className="rt-msg-time-date">
                                  <Moment format="MMM D, YYYY">{item.callDate}</Moment>
                                </span>
                                <span className="rt-msg-time-subtext">
                                  {moment(item.callTime?.replace(":00", ""), "hhmm").format("h:mm a")}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span className="rt-call-duration-tag">
                                <i className="fa fa-hourglass-half" aria-hidden="true" /> {item.duration} Min
                              </span>
                            </td>
                            <td>
                              {item.comments ? (
                                <NotesPopover notes={item.comments} placement={key === 0 ? "bottom" : "top"} />
                              ) : (
                                <span className="wf-empty-value">No notes</span>
                              )}
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">
                                    {(item.performer || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase()}
                                  </span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{item.performer || "Unknown"}</span>
                                  {item.email && <span className="wf-name-title">{item.email}</span>}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="rt-form-buttons-row" onClick={(e) => e.stopPropagation()}>
                                {canDelete && (
                                  <button
                                    type="button"
                                    className="btn-action-search btn-danger-search"
                                    onClick={() => handleDeleteComment(item)}
                                    title="Delete"
                                    disabled={isDeleteLoading && deletingPhoneId === item.phoneId}
                                    style={{ width: "32px", height: "30px", minWidth: "32px", padding: 0, justifyContent: "center" }}
                                  >
                                    {isDeleteLoading && deletingPhoneId === item.phoneId ? (
                                      <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                                    ) : (
                                      <i className="fa fa-trash-o" aria-hidden="true" />
                                    )}
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ─── Profile Tab (Add/Edit Note) ─── */}
        {selectedKey === "profile" && (
          <div className="rt-msg-panel is-form-panel">
            <PhoneCallApplicantPopup
              handleSubmit={handleSubmit}
              selectedItem={selectedPhoneCall}
              handleEditComment={handleEditComment}
              handleCancel={() => handleSelectTab("home")}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default PhoneCallApplicant;
